
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soccer/match/[id]",
      function () {
        return require("private-next-pages/soccer/match/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soccer/match/[id]"])
      });
    }
  